export default __webpack_public_path__ + "static/media/slide01.3d4f95de.webp";